import { useMemo } from 'react';

import { Backspace, SearchOutlined } from '@material-ui/icons';
import { ListItem } from 'design-system';

import { DEVICE_ID_PREFIX, EMAIL_REGEX, parseDeviceString } from 'utils';

export const SearchError = ({ searchTerm, setSearchTerm, inputRef, onSearch }: any) => {
  const noResults = (
    <>
      No results for <b>'{searchTerm}'</b>
    </>
  );

  const handleSearchByDeviceId = () => {
    const searchByDeviceIdTerm = `${DEVICE_ID_PREFIX}:${searchTerm}`;
    setSearchTerm(searchByDeviceIdTerm);
    onSearch(searchByDeviceIdTerm);
  };

  const showSearchByDeviceIdListItem = useMemo(() => {
    const parsedDeviceString = parseDeviceString(searchTerm);

    return !!searchTerm && !parsedDeviceString && !EMAIL_REGEX.test(searchTerm);
  }, [searchTerm]);

  return (
    <>
      <ListItem
        button
        onClick={(event) => {
          event.preventDefault();
          setSearchTerm('');
          inputRef?.current?.focus();
        }}
        iconTooltipText="Clear"
        icon={<Backspace />}
        text={noResults}
      />
      {showSearchByDeviceIdListItem && (
        <ListItem
          button
          onClick={handleSearchByDeviceId}
          iconTooltipText="Search by Device ID"
          icon={<SearchOutlined />}
          text="Search by Device ID"
        />
      )}
    </>
  );
};
